import { Box, Stack } from '@mui/joy';
import AspectRatio from '@mui/joy/AspectRatio';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import convertJsonToHtml from '../../utils/convertJsonToHtml';

const DEFAULT_IMAGE_SRC =
  'https://sccstorageaccount.blob.core.windows.net/uploads/1696451571350.jpg';

const propTypes = {
  id: PropTypes.string.isRequired,
  joined: PropTypes.bool.isRequired,
  image: PropTypes.string.isRequired,
  members: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  updateEvent: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  dateStart: PropTypes.string.isRequired,
  dateEnd: PropTypes.string,
  timeStart: PropTypes.string.isRequired,
};

type componentProps = PropTypes.InferProps<typeof propTypes>;

function EventCard(props: componentProps) {
  const {
    id,
    image,
    members,
    title,
    description,
    isAdmin,
    dateStart,
    dateEnd,
    timeStart,
    onClickEdit,
  } = props;

  return (
    <Link to={id}>
      <Card
        sx={{
          // height: '100%',
        }}
      >
        <div>
          <Typography level="title-lg">{title}</Typography>
        </div>
        <AspectRatio ratio="4/3">
          <img
            src={image || DEFAULT_IMAGE_SRC}
            // srcSet="https://images.unsplash.com/photo-1527549993586-dff825b37782?auto=format&fit=crop&w=286&dpr=2 2x"
            loading="lazy"
            alt=""
          />
        </AspectRatio>
        <CardContent>
          <Typography level="body-sm">
            {convertJsonToHtml(description)}
          </Typography>
          <Stack gap={1}>
            <Stack gap={3} direction={'row'} justifyContent={'space-between'}>
              <Box>
                <Typography level="body-xs">Deelnemers</Typography>
                <Typography>{members}</Typography>
              </Box>

              <Box>
                <Typography level="body-xs">Wanneer</Typography>
                <Typography>
                  {/* Date */}
                  <Typography level="body-sm">
                    {dayjs(dateStart).isSame(dayjs(new Date()), 'day')
                      ? `Vandaag ${dayjs(dateStart).format('HH:mm')}`
                      : dayjs(dateStart).format('DD MMMM YYYY HH:mm')}
                  </Typography>
                </Typography>
              </Box>
            </Stack>
            <Button>Bekijken</Button>
          </Stack>
        </CardContent>
      </Card>
    </Link>
  );
}

EventCard.propTypes = propTypes;

export default EventCard;
